// File: /js/shared/components/nightMode.js
// Day/night theme toggle (grafted from sia-formation; see
// docs/night-mode-recipe.md).
//
// The server renders the initial `<html data-theme="dark">` state
// (shared\utils\NightMode — cookie `rescos_night_mode` on/off, absent = auto
// 22:00→06:00 Zurich). This handler flips the attribute LIVE (no reload — the
// whole theme is the CSS token layer in base/_variables.css) and pins the
// explicit choice in the cookie for a year, after which that browser is out of
// auto mode. The ☾/☀ glyph swap is pure CSS off the html attribute
// (layout/header.css), so there is no glyph logic here.
//
// Dispatch rides the existing domExtensions data-ui registry (no new document
// listener); registered at module load via the side-effect import in
// initSharedUI.js.

import { registerUiHandler } from '/js/shared/extensions/domExtensions.js';

const COOKIE = 'rescos_night_mode';

registerUiHandler('click', 'night-toggle', () => {
  const next = document.documentElement.getAttribute('data-theme') !== 'dark';

  if (next) {
    document.documentElement.setAttribute('data-theme', 'dark');
  } else {
    document.documentElement.removeAttribute('data-theme');
  }

  document.cookie = `${COOKIE}=${next ? 'on' : 'off'}; path=/; max-age=31536000; SameSite=Lax`;
});
